<template>
  <div class="input-container"
       :class="{
         'filled': isFilled,
         'focused': isFocused
       }">
    <span class="placeholder">{{ label }}</span>
    <input min="0"
           :disabled="disabled"
           ref="inputElement"
           :step="isCurrency ? '0.01' : '1'"
           :type="isCurrency ? 'number' : type"
           :autocomplete="autocomplete"
           @focus="onFocus"
           @blur="onBlur"
           @input="$emit('input', $event.target.value)"
           :style="{paddingRight: clearable ? '28px' : 0}"
           :value="value">
      <button type="button" class="clear" @click="$emit('input', null)" v-if="clearable && !disabled">
          <b-icon icon="close" size="is-small"></b-icon>
      </button>
  </div>
</template>

<script>
  import Inputmask from 'inputmask'

  export default {
    props: {
        value: {
            type: null,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            required: false,
            default: 'text'
        },
        autocomplete: {
            type: String,
            required: false,
            default: 'on'
        },
      mask: {
        type: String,
        required: false,
        default: null
      },
      clearable: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        isFilled: false,
        isFocused: false
      }
    },
    methods: {
      onFocus() {
        this.isFilled = true
        this.isFocused = true
      },
      onBlur() {
        this.isFocused = false
        if (this.value === '' || this.value === null)
          this.isFilled = false
      },
    },
    mounted() {
      this.onFocus()
      this.onBlur()
      /*if (this.mask) {
        let im = new Inputmask(this.mask)
        im.mask(this.$refs.inputElement)
      }*/
    },
    computed: {
      isCurrency() {
        return this.type === 'currency'
      }
    },
    watch: {
      value() {
        this.onFocus()
        this.onBlur()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .input-container {
    width: 100%;
    height: 52px;
    position: relative;

    .placeholder {
      position: absolute;
      top: 20px;
      color: #686868;
      z-index: 1;
      font-size: 14px;
      transition: all .2s ease;
    }

    &.filled .placeholder {
      top: 0;
      font-size: 13px;
      color: #afafaf;
    }

    &.focused .placeholder {
      color: #3498db;
    }

    input {
        position: relative;
        z-index: 1;
        background: transparent;
        margin: 18px 0 0 0;
        padding: 6px 0 8px 0;
        width: 100%;
        border: 0;
        border-bottom: 1px solid #d7dce9;
        font-size: 14px;
        transition: border-bottom-color .2s ease;

        &[disabled] {
            color: #aaa;
        }
    }

    &.focused input {
      border-color: #3498db;
    }

    .clear {
      display: block;
      position: absolute;
      z-index: 99;
      top: 25px;
      right: 5px;
      padding: 0 0 0 0;
      margin: 0;
      border: 0;
      background: #e7e7e7;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      text-align: center;
      line-height: 16px;
      font-size: 10px !important;

      &:hover {
        background: #d8d8d8;
        cursor: pointer;
      }
    }
  }
</style>
